import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserChangePassword } from './user-change-password';
import { AuthService } from '../auth/auth-service.service';
import { Observable, Subject } from 'rxjs';
import { options } from 'devexpress-reporting/scopes/reporting-designer-controls-pivotGrid-metadata';
import { language } from 'devexpress-reporting/scopes/reporting-designer-controls-metadata';

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
  private serviceUrl = environment.API_URL + 'customer';
  private userServiceUrl = environment.API_URL + 'user';
  private customerLogoUrl = environment.API_URL + 'klantlogo';

  private afdelingChangeSubject = new Subject<any>();
  private customerChangeSubject = new Subject<any>();
  private setCustomerSubject = new Subject<any>();
  private showChooseLanguageSubject = new Subject<any>();
  private languageChangeSubject = new Subject<any>();

  constructor(private http: HttpClient, private authService: AuthService) { }

  getActiveCustomer(): Observable<any> {
    return this.http.get(this.serviceUrl + '/active')
  }

  getAvailableCustomers(): Observable<any> {
    return this.http.get(this.serviceUrl + '/available')
  }

  getActiveCustomerId(): string {
    return this.authService.getDecodedToken()['ActiveKlantId'] ?? '0'
  }

  getActiveDepartment(): any {
    return this.authService.getDecodedToken()['ActiveAfdelingId'] ?? '0'
  }

  changePassword(changePassword: UserChangePassword): Observable<any> {
    return this.http.post(this.userServiceUrl + '/ChangePassword', changePassword)
  }

  getCustomerLogo(): any {
    return this.http.get(this.customerLogoUrl, { responseType: 'blob' })
  }

  changeCurrentAfdeling() {
    this.afdelingChangeSubject.next(true);
  }

  onChangedCurrentAfdeling(): Observable<any> {
    return this.afdelingChangeSubject.asObservable();
  }

  changeCurrentCustomer() {
    this.customerChangeSubject.next(true);
  }

  onChangeCurrentCustomer(): Observable<any> {
    return this.customerChangeSubject.asObservable();
  }

  showChooseLanguage() {
    this.showChooseLanguageSubject.next(true);
  }

  onShowChooseLanguage() {
    return this.showChooseLanguageSubject.asObservable();
  }

  setCurrentCustomer(customer) {
    this.setCustomerSubject.next(customer);
  }

  OnSetCurrentCustomer(): Observable<any> {
    return this.setCustomerSubject.asObservable();
  }

  getUserPreferredLanguage(): string {
    const lpf = localStorage.getItem('UserPreferredLanguage');
    if (lpf == null) {
      const decodedToken = this.authService.getDecodedToken();
      var pf = decodedToken['PreferredLanguage'] ?? null;
      if (pf != null) localStorage.setItem('UserPreferredLanguage', pf);
      else localStorage.removeItem('UserPreferredLanguage');
      return pf;
    } else {
      return lpf;
    }
  }

  setUserPreferredLanguage(preferredLanguage: string): Observable<any> {
    localStorage.setItem('UserPreferredLanguage', preferredLanguage);
    return this.http.post(this.userServiceUrl + '/ChangeLanguage', null, {
      params: { language: preferredLanguage }
    })
  }

  languageChange() {
    this.languageChangeSubject.next(null);
  }

  onLanguageChange() {
    return this.languageChangeSubject.asObservable();
  }
}
